// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { windowDock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-window-dock': IconWindowDock;
    }
}

/**
 * The icon component for the 'windowDock' icon
 */
export class IconWindowDock extends IconSvg {
    public constructor() {
        super(windowDock16X16);
    }
}

registerIconSvg('icon-window-dock', IconWindowDock);
export const iconWindowDockTag = 'nimble-icon-window-dock';
